import PropTypes from 'prop-types';
import cx from 'classnames';

import styles from './OrderedList.css';
import { OrderedList } from './OrderedList';

const OrderedListPlugin = ({
  className,
  ORDERED_LIST_TAG,
  ...attributes
} = {}) => ({
  renderElement: OrderedList({
    className: cx(styles.orderedList, className),
    ORDERED_LIST_TAG,
    ...attributes,
  }),
});

OrderedListPlugin.propTypes = {
  className: PropTypes.string,
  ORDERED_LIST_TAG: PropTypes.node,
};

export { OrderedListPlugin };
